module.exports = __webpack_public_path__ + "static/img/JiuXiang_Banner_spring.f6777432.jpg";